export class ProgramInterpretedDataModel
{
    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            if (json.TimeStamp) this.TimeStamp = new Date(json.TimeStamp);
        }
    }

    public ActivityCode: number;
    public Description: string;
    public IsInteresting = false;
    public IsManualStart = false;
    public IsOnHold = false;
    public IsRunning = false;
    public Number: number;
    public SecondsRemaining: number;
    public SecondsReported: number;
    public ShouldUseTimer = false;
    public Status: string;
    public TimeStamp: Date;

    public get adjustedSecondsRemaining(): number
    {
        const offsetInSeconds = (new Date().getTime() - this.TimeStamp.getTime()) / 1000;
        return offsetInSeconds <= 0 ? this.SecondsRemaining : this.SecondsRemaining - offsetInSeconds;
    }

}
